// PROPOSITO: la raiz manda a cada quien a su casa segun su rol.
// DEPENDENCIAS: src/store/auth, src/router/destinos.
import { Navigate } from 'react-router-dom'
import { usarAuth } from '@/store/auth'
import { inicioSegunRol } from './destinos'

export function Raiz() {
  const perfil = usarAuth(e => e.perfil)
  const cargando = usarAuth(e => e.cargando)
  if (cargando) return null
  return <Navigate to={perfil ? inicioSegunRol(perfil.rol) : '/entrar'} replace />
}
